import { render, staticRenderFns } from "./BillPrint.vue?vue&type=template&id=22577986&"
import script from "./BillPrint.vue?vue&type=script&lang=js&"
export * from "./BillPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports